"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RebateTakeoutOptions = exports.RebateTakeoutOptionsEnum = void 0;
var RebateTakeoutOptionsEnum;
(function (RebateTakeoutOptionsEnum) {
    RebateTakeoutOptionsEnum["GetToKnowUs"] = "get-to-know-us";
    RebateTakeoutOptionsEnum["PartnerWithUs"] = "partner-with-us";
})(RebateTakeoutOptionsEnum = exports.RebateTakeoutOptionsEnum || (exports.RebateTakeoutOptionsEnum = {}));
exports.RebateTakeoutOptions = {
    GetToKnowUs: [27, 28],
    PartnerWithUs: [33, 34, 35, 43, 44],
};
